import { useEffect, useState } from "react";
import api from "@/lib/api";
import Hero from "@/components/home/Hero";
import QuickLinks from "@/components/home/QuickLinks";
import WorldMapSection from "@/components/home/WorldMapSection";
import EventsSection from "@/components/home/EventsSection";
import GenreRow from "@/components/home/GenreRow";
import BottomTriad from "@/components/home/BottomTriad";
import AIContentBlock from "@/components/AIContentBlock";

export default function Home() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/home").then((r) => setData(r.data)).catch(console.error);
  }, []);

  if (!data) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="home-loading">
        <span className="eq-bars" style={{ height: 40 }}><span /><span /><span /><span /><span /></span>
      </div>
    );
  }

  return (
    <div data-testid="home-page">
      <Hero countries={data.countries} />
      <QuickLinks />
      <section className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-4 grid grid-cols-1 xl:grid-cols-2 gap-5 items-stretch">
        <WorldMapSection countries={data.countries} />
        <EventsSection events={data.events} />
      </section>
      <GenreRow genres={data.genres} />
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <AIContentBlock pageKey="home" topic="Global music discovery - one world, a million sounds" imgQuery="world music festival crowd celebration" />
      </div>
      <BottomTriad news={data.news} stories={data.stories} heritage={data.heritage} />
    </div>
  );
}
